import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import SignType from "../../domain/signType";
import signTypeColor from "./signTypeColor";
import styles from "./SignTypeChip.module.css";

const SignTypeChip = React.forwardRef(function SignTypeChip(
  { signedType, label, className },
  ref,
) {
  const isLivestream = signedType === SignType.livestream;
  const background = signTypeColor(signedType);

  return (
    <span
      ref={ref}
      className={clsx(
        styles.root,
        isLivestream && styles.livestream,
        background && styles.coloured,
        className,
      )}
      style={background ? { backgroundColor: background } : undefined}
      data-sign-type={signedType}
    >
      <span className={isLivestream ? styles.goldText : undefined}>
        {label}
      </span>
    </span>
  );
});

SignTypeChip.displayName = "SignTypeChip";

SignTypeChip.propTypes = {
  signedType: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default SignTypeChip;
